<script setup>
import { renderRichText2 } from '~/utils/richtext'
const props = defineProps({ blok: Object })
const body = computed(() => renderRichText2(props.blok.body))
</script>

<template>
	<div v-editable="blok" class="border-l-8 border-x-primary-500 w-full mx-auto max-w-screen-md pl-6 mt-20 clear-left">
		<h3 v-if="blok.title" class="text-3xl font-bold">{{ blok.title }}</h3>
		<div class="text-xl font-thin mt-2 conclusion-body" v-html="body"></div> 
	</div> 
</template>

<style>
.conclusion-body a {
	color: #BF8DFF;
	font-weight: 300;
}
</style>
 